"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constant = require("../../styles/constant");
var _templateObject;
const badgeAppearance = function () {
  let appearance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let badgeColor, color;
  switch (appearance) {
    case 'primitive':
      badgeColor = (0, _constant.get)('colors.primary.blue.500');
      color = (0, _constant.get)('colors.functional.grey.50');
      break;
    case 'primaryInverted':
      badgeColor = (0, _constant.get)('colors.functional.grey.50');
      color = (0, _constant.get)('colors.functional.grey.900');
      break;
    case 'important':
      badgeColor = (0, _constant.get)('colors.secondary.red.500');
      color = (0, _constant.get)('colors.functional.grey.50');
      break;
    case 'added':
      badgeColor = (0, _constant.get)('colors.secondary.teal.100');
      color = (0, _constant.get)('colors.seconadry.teal.800');
      break;
    case 'removed':
      badgeColor = (0, _constant.get)('colors.secondary.red.100');
      color = (0, _constant.get)('colors.secondary.red.800');
      break;
    case 'default':
      badgeColor = (0, _constant.get)('colors.functional.grey.300');
      break;
    default:
      badgeColor = (0, _constant.get)('colors.functional.grey.300');
  }
  return {
    badgeColor,
    color
  };
};
const StyledBadge = _styledComponents["default"].div.withConfig({
  shouldForwardProp: prop => !['max', 'value'].includes(prop)
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: inline-block;\n  min-width: 1px;\n  padding: 2px 6px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: normal;\n  line-height: 1;\n  text-align: center;\n  background-color: ", ";\n  color: ", ";\n"])), _ref => {
  let {
    appearance
  } = _ref;
  return badgeAppearance(appearance).badgeColor;
}, _ref2 => {
  let {
    appearance
  } = _ref2;
  return badgeAppearance(appearance).color;
});
var _default = exports["default"] = StyledBadge;